// extracted by mini-css-extract-plugin
export var addButton = "_dl-4";
export var contentBlockImage = "_dl-i";
export var contentBlockWidgetPreview = "_dl-g";
export var fulfillmentCutoffWidgetPreview = "_dl-9";
export var imageBackdrop = "_dl-6";
export var imageIcon = "_dl-8";
export var lowProfileImageContainer = "_dl-b";
export var lowProfileImageIcon = "_dl-f";
export var lowProfileImageIconContainer = "_dl-e";
export var lowProfileImagePlaceholder = "_dl-d";
export var lowProfileProductImage = "_dl-c";
export var lowProfileProductUpsellWidgetPreview = "_dl-a";
export var productCard = "_dl-5";
export var productImage = "_dl-7";
export var productReviewsWidgetPreview = "_dl-h";
export var progressBar = "_dl-1";
export var progressBarFill = "_dl-2";
export var progressBarTrack = "_dl-3";
export var shippingOptionWidgetPreview = "_dl-j";
export var shippingUpsellProgressBar = "_dl-k";
export var thresholdUpsellWidgetPreview = "_dl-0";